import React from "react";

function hasReferenceData({
  clients = [],
  amount = "",
  goal = "",
  fusionAllocations = [],
}) {
  return (
    clients.length > 0 ||
    !!amount ||
    !!goal ||
    fusionAllocations.length > 0
  );
}

export const ISPReferenceBanner = ({
  clients = [],
  amount = "",
  goal = "",
  fusionAllocations = [],
  onDismiss,
}) => {
  if (
    !hasReferenceData({
      clients,
      amount,
      goal,
      fusionAllocations,
    })
  ) {
    return null;
  }

  return (
    <div
      className="alert alert-info alert-dismissible fade show mb-3"
      role="alert"
    >
      <strong>Creating proposal from Investment Strategy Plan</strong>
      <div className="mt-2" style={{ fontSize: "13px" }}>
        {clients.length > 0 && (
          <div>
            <strong>Clients: </strong>
            {clients.map((client, index) => (
              <span key={`${client.name || "client"}-${index}`}>
                {client.name}
                {client.isPrimary && (
                  <span
                    className="badge ml-1"
                    style={{
                      fontSize: "9px",
                      backgroundColor: "#385EA4",
                      color: "#fff",
                    }}
                  >
                    Primary
                  </span>
                )}
                {index < clients.length - 1 && ", "}
              </span>
            ))}
          </div>
        )}

        {amount && (
          <div>
            <strong>Amount: </strong>
            {amount}
          </div>
        )}

        {goal && (
          <div>
            <strong>Goal: </strong>
            {goal}
          </div>
        )}

        {fusionAllocations.length > 0 && (
          <div className="mt-2">
            <strong>Weighted Strategies</strong>
            <table
              className="table table-sm table-bordered mt-1 mb-0"
              style={{ maxWidth: "600px", backgroundColor: "#fff" }}
            >
              <thead>
                <tr>
                  <th>Strategy</th>
                  <th style={{ width: "100px" }}>Weight</th>
                </tr>
              </thead>
              <tbody>
                {fusionAllocations.map((allocation, index) => (
                  <tr key={`${allocation.strategy || "strategy"}-${index}`}>
                    <td>{allocation.strategy || "Strategy"}</td>
                    <td>{allocation.percentage ? `${allocation.percentage}%` : "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {onDismiss && (
        <button
          type="button"
          className="close"
          aria-label="Dismiss"
          onClick={onDismiss}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  );
};

export default ISPReferenceBanner;
